import React, { useState, useEffect } from "react";
import {
  Card,
  Table,
  FormControl,
  Button,
  Modal,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import Swal from "sweetalert2";

import Layout from "../../layout/default";
import Block from "../../components/Block/Block";
import instance from "../api";
import ReactPaginate from "react-paginate";
import { FaTrash } from "react-icons/fa"; // Import trash icon
import { Icon } from "../../components";

const DChargeCountryDetails = () => {
  const { country_id } = useParams();
  // const [regions, setRegions] = useState([]);
  const [rates, setRates] = useState([]);
  // const [ taxData, setTaxData ] = useState({});
  const [rateData, setRateData] = useState({});
  const [countryName, setCountryName] = useState("");

  const [currentPage, setCurrentPage] = useState(0);

  // new code
    const navigate = useNavigate();
    
      const [countryList, setCountryList] = useState([]);


  const [showModal, setShowModal] = useState(false);

  const [price, setPrice] = useState("");
  const [weight, setWeight] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    country: false,
    weight: false,
    price: false,
  });

  const handleShowModal = () => setShowModal(true);

  const handleCloseModal = () => {
    setShowModal(false);
    navigate(`/deliverycountry/${country_id}`);
    setPrice("");
    setWeight("");
    setFieldErrors({
      weight: false,
      price: false,
    });
  };

  const validateForm = () => {
    const errors = {};
    if (!price) errors.price = true;
    if (!weight) errors.weight = true;

    setFieldErrors(errors);
    return Object.values(errors).every((error) => !error);
  };

  const postData = async () => {
    if (!validateForm()) return;
    try {
      const payload = {
          country_id: country_id,
          data: [ {
             price: price,
          weight: weight
          }]
          
      };
      // console.log("payload", payload);

      const response = await instance.post(
        "api/DeliveryCharge/create",
        payload
      );
      handleCloseModal();
      fetchData();
      Swal.fire("Success", "Delivery rate updated successfully!", "success");
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "Failed to update delivery rate!", "error");
    }
  };
    
    
const getCountryList = async () => {
    try {
      const response = await instance.get("api/Master/Country");
      const activeCountries = response.data.rows.filter((c) => c.status === 1);
        setCountryList(activeCountries);
        const country = activeCountries.find((c) => c.country_id == country_id);
        // console.log("country", country);
        setCountryName(country.name);   
      // setCountryList(response.data.rows);
    } catch (error) {
      console.error("Error fetching country list", error);
    }
  };
  useEffect(() => {
    getCountryList();
  }, []);

  // new code ends here

  const itemsPerPage = 10;
//   console.log(country_id);

  const fetchData = async () => {
    try {
      const response = await instance.get(`api/DeliveryCharge/${country_id}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json; charset=utf-8",
          "ngrok-skip-browser-warning": "true",
        },
      });
      // setRegions(response.data.rows);
      setRates(response.data.rows);
    //   if (response.data.rows.length > 0) {
    //     setCountryName(response.data.rows[0].country_name);
    //   }
      // Initialize rateData based on fetched rates
      const initialRateData = response.data.rows.reduce((acc, rate) => {
        acc[rate.charge_id] = { weight: rate.weight, price: rate.price };
        return acc;
      }, {});
      setRateData(initialRateData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [country_id]);

  const handleWeightChange = (charge_id, value) => {
    setRateData((prevData) => ({
      ...prevData,
      [charge_id]: { ...prevData[charge_id], weight: value },
    }));
  };

  const handlePriceChange = (charge_id, value) => {
    setRateData((prevData) => ({
      ...prevData,
      [charge_id]: { ...prevData[charge_id], price: value },
    }));
  };

  const updateRateSetting = async (charge_id) => {
    const rateDetails = rateData[charge_id];
    if (rateDetails) {
      try {
        await instance.put(`api/DeliveryCharge/update/${charge_id}`, {
          country_id: country_id,
          weight: rateDetails.weight,
          price: rateDetails.price,
        });
      } catch (error) {
        console.error("Error updating tax setting:", error);
      }
    }
  };

  const handleBlur = (charge_id) => {
    if (rateData[charge_id]) {
      updateRateSetting(charge_id);
    }
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const deleteRate = async (charge_id) => {
    try {
      await instance.delete(`api/DeliveryCharge/delete/${charge_id}`);
      setRates(rates.filter((rate) => rate.charge_id !== charge_id));
    } catch (error) {
      console.error("Error deleting rate:", error);
    }
  };
    
    
    

  const displayRates = rates.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );
  // const displayRegions = regions.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  return (
    <Layout title="Country Details" content="container">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">{countryName}</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Button
                  className="d-md-none"
                  size="md"
                  variant="primary"
                  onClick={handleShowModal}
                >
                  <Icon name="plus" />
                  <span>Add</span>
                </Button>
              </li>
              <li>
                <Button
                  className="d-none d-md-inline-flex"
                  variant="primary"
                  onClick={handleShowModal}
                >
                  <Icon name="plus" />
                  <span>Add Rate</span>
                </Button>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          <div className="p-3">
            <Table bordered>
              <thead>
                <tr>
                  <th>Weight</th>
                  <th>Price</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rates.map((rate) => (
                  <tr key={rate.charge_id}>
                    {/* <td>{rate.WebtagZone.name}</td> */}
                    <td>
                      <div className="d-flex align-items-center">
                        <FormControl
                          type="text"
                          value={rateData[rate.charge_id]?.weight || 0}
                          // value={0}
                          onChange={(e) =>
                            handleWeightChange(rate.charge_id, e.target.value)
                          }
                          onBlur={() => handleBlur(rate.charge_id)}
                          className="me-2"
                          style={{ maxWidth: "80px" }}
                        />
                        <span>kg</span>
                      </div>
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={rateData[rate.charge_id]?.price || 0}
                        onChange={(e) =>
                          handlePriceChange(rate.charge_id, e.target.value)
                        }
                        onBlur={() => handleBlur(rate.charge_id)}
                        className="me-2"
                        style={{ maxWidth: "100px" }}
                      />
                    </td>
                    <td>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => deleteRate(rate.charge_id)}
                      >
                        <FaTrash color="red" />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"..."}
                pageCount={Math.ceil(rates.length / itemsPerPage)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
              <div className="pagination-summary">
                {`Showing ${currentPage * itemsPerPage + 1} to ${Math.min(
                  (currentPage + 1) * itemsPerPage,
                  rates.length
                )} of ${rates.length} entries`}
              </div>
            </div>
          </div>
        </Card>
      </Block>

      {/* new code */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{"Add Rate"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>Weight</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter  weight"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                  isInvalid={fieldErrors.price}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a weight in number.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>Price</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter a Price"
                  value={price}
                  // onChange={(e) => setPrice(parseFloat(e.target.value))}
                  onChange={(e) => setPrice(e.target.value)}
                  isInvalid={fieldErrors.price}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a price in number.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Button variant="primary" onClick={postData}>
              {"Add Rate"}
            </Button>{" "}
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      {/* new code ends here */}
    </Layout>
  );
};

export default DChargeCountryDetails;
